<template>
  <div
    v-if="enableMaxLimit"
    class="flex justify-between items-start px-2 py-1 gap-6"
  >
    <div
      v-if="currentState.message"
      class="flex items-start gap-1 font-semibold text-sm leading-[15px]"
      :class="currentState.messageClass"
    >
      <ThemeImage
        class="w-3.5 h-3.5"
        :icon="currentState.icon"
        :alt="currentState.alt"
      />
      {{ currentState.message }}
    </div>

    <div v-else></div>

    <div
      class="text-sm leading-[15px] font-semibold"
      :class="currentState.countClass"
    >
      {{ charCount }}/{{ maxLimit }}
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { characterLimitStates } from "@/src/constants/characterLimitConstants.js";

const props = defineProps({
  enableMaxLimit: { type: Boolean, default: false },
  charCount: { type: Number, default: 0 },
  maxLimit: { type: Number, default: 300 },
  cautionLimit: { type: Number, default: 200 },
  cautionText: { type: String, default: "" },
});

const getCharacterLimitState = (
  charCount,
  maxLimit,
  cautionLimit,
  cautionText,
) => {
  const { error, caution, normal } = characterLimitStates;

  if (error.condition(charCount, maxLimit)) {
    return {
      ...error,
      message: error.message,
    };
  }

  if (caution.condition(charCount, cautionLimit, maxLimit, cautionText)) {
    return {
      ...caution,
      message: caution.message(cautionText),
    };
  }

  return normal;
};

const currentState = computed(() =>
  getCharacterLimitState(
    props.charCount,
    props.maxLimit,
    props.cautionLimit,
    props.cautionText,
  ),
);
</script>
